import React from "react";
import { ArrowUp } from "lucide-react";
import { container } from "./editorial";
import { cn } from "../lib/utils";

export default function Footer() {
  return (
    <footer className="border-t border-edge">
      <div className={cn(container, "flex flex-col gap-2 py-6 text-sm text-fg-subtle sm:flex-row sm:items-center sm:justify-between")}>
        <p>© {new Date().getFullYear()} Danial Darabi</p>
        <p className="font-mono text-xs uppercase tracking-[0.12em]">Senior PM · AI &amp; ML · Berlin</p>
        <a href="#hero" className="inline-flex min-h-[44px] items-center gap-2 self-start transition-colors hover:text-fg sm:self-auto">
          Back to top
          <ArrowUp className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </footer>
  );
}
